import { IM190StoryItem } from '~/lib/data-contract';
import { ImageMedia } from '~/shared/components/ImageMedia/ImageMedia';
import Link from '~/shared/components/Link/Link';
import { lgCondition, xsCondition } from '~/theme/lib/breakpoints';

import styles from './m190story.module.css';

export type M190StoryProps = IM190StoryItem;

export const imageSizes = [`${lgCondition} 25vw`, `${xsCondition} 50vw`].join(', ');

export const M190Story = (props: M190StoryProps) => {
	const { link, image } = props;
	const { url = '#', title, ...linkProps } = link || {}; // TODO: Check BE why property is marked as required not coming

	const newAlt = `Image of ${image.alt || title}`;

	return (
		<div className={styles.root}>
			<Link
				className={styles.link}
				href={url}
				isCustomStyle
				{...linkProps}
			>
				<div className={styles.imageContainer}>
					<div className={styles.storyImage}>
						<ImageMedia
							sizes={imageSizes}
							image={{ ...image, alt: newAlt }}
							fill
							objectFit="cover"
						/>
					</div>
				</div>
				{title ? <span className={styles.storyLabel}>{title}</span> : null}
			</Link>
		</div>
	);
};
